import React, { useEffect, useState } from 'react'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'
import { makeStyles, Snackbar } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  snackbar: {
    top: 5,
    width: '100%'
  }
}))

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const OfflineToast: React.FC = () => {
  const [isOnline, setNetwork] = useState(window.navigator.onLine)
  const [open, setOpen] = useState(false)

  const updateNetwork = () => {
    console.log(window.navigator.onLine)
    setNetwork(window.navigator.onLine)
  }

  useEffect(() => {
    window.addEventListener('offline', updateNetwork)
    window.addEventListener('online', updateNetwork)
    return () => {
      window.removeEventListener('offline', updateNetwork)
      window.removeEventListener('online', updateNetwork)
    }
  })

  useEffect(() => {
    if (isOnline !== undefined) {
      setOpen(!isOnline)
    } else {
      setOpen(false)
    }
  }, [isOnline])

  const classes = useStyles()
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      className={classes.snackbar}
    >
      <Alert
        onClose={() => {
          setOpen(false)
        }}
        severity="error"
      >
        Sem conexão de internet
      </Alert>
    </Snackbar>
  )
}

export default OfflineToast
